import React from "react";

const Datenschutz = () => {
  return (
    <div className="page-content">
      <h1>Datenschutzerklärung</h1>

      <h2>
        <strong>Privacy policy – Loewe Saal GmbH</strong>
      </h2>
      <h3>
        <strong>1. An overview of data protection</strong>
      </h3>
      <h4>
        <strong>General information</strong>
      </h4>
      <p>
        The following information will provide you with an easy to navigate
        overview of what will happen with your personal data when you visit our
        website. The term „personal data" comprises all data that can be used to
        personally identify you. For detailed information about the subject
        matter of data protection, please consult our Data Protection
        Declaration, which we have included beneath this copy.
      </p>

      <h4>
        <strong>Data recording on our website</strong>
      </h4>
      <p>
        <strong>
          Who is the responsible party for the recording of data on this website
          (i.e. the „controller")?
        </strong>
      </p>
      <p>
        The data on this website is processed by the operator of the website,
        whose contact information is available under section „Information
        Required by Law" on this website.
      </p>

      <h4>
        <strong>How do we record your data?</strong>
      </h4>
      <p>
        We collect your data as a result of your sharing of your data with us.
        This may, for instance be information you enter into our contact form.
      </p>

      <p>
        Our IT systems automatically record other data when you visit our
        website. This data comprises primarily technical information (e.g. web
        browser, operating system or time the site was accessed). This
        information is recorded automatically when you access our website.
      </p>

      <h4>
        <strong>What are the purposes we use your data for?</strong>
      </h4>
      <p>
        A portion of the information is generated to guarantee the error free
        provision of the website. Other data may be used to analyse your user
        patterns.
      </p>

      <h4>
        <strong>
          What rights do you have as far as your information is concerned?
        </strong>
      </h4>
      <p>
        You have the right to receive information about the source, recipients
        and purposes of your archived personal data at any time without having
        to pay a fee for such disclosures. You also have the right to demand
        that your data are rectified, blocked or eradicated. Please do not
        hesitate to contact us at any time under the address disclosed in
        section „Information Required by Law" on this website if you have
        questions about this or any other data protection related issues. You
        also have the right to log a complaint with the competent supervising
        agency.
      </p>

      <p>
        Moreover, under certain circumstances, you have the right to demand the
        restriction of the processing of your personal data. For details, please
        consult the Data Protection Declaration under section „Right to
        Restriction of Data Processing."
      </p>

      <h4>
        <strong>Analysis tools and tools provided by third parties</strong>
      </h4>
      <p>
        There is a possibility that your browsing patterns will be statistically
        analysed when your visit our website. Such analyses are performed
        primarily with cookies and with what we refer to as analysis programmes.
        As a rule, the analyses of your browsing patterns are conducted
        anonymously; i.e. the browsing patterns cannot be traced back to you.
      </p>

      <p>
        You have the option to object to such analyses or you can prevent their
        performance by not using certain tools. For detailed information about
        the tools and about your options to object, please consult our Data
        Protection Declaration below.
      </p>

      <h3>
        <strong>2. General information and mandatory information</strong>
      </h3>
      <h4>
        <strong>Data protection</strong>
      </h4>
      <p>
        The operators of this website and its pages take the protection of your
        personal data very seriously. Hence, we handle your personal data as
        confidential information and in compliance with the statutory data
        protection regulations and this Data Protection Declaration.
      </p>

      <p>
        Whenever you use this website, a variety of personal information will be
        collected. Personal data comprises data that can be used to personally
        identify you. This Data Protection Declaration explains which data we
        collect as well as the purposes we use this data for. It also explains
        how, and for which purpose the information is collected.
      </p>

      <p>
        We herewith advise you that the transmission of data via the Internet
        (i.e. through e-mail communications) may be prone to security gaps. It
        is not possible to completely protect data against third party access.
      </p>

      <h4>
        <strong>
          Information about the responsible party (referred to as the
          "controller" in the GDPR)
        </strong>
      </h4>
      <p>The data processing controller on this website is:</p>

      <p>
        <strong>Loewe Saal GmbH</strong>
        <br />
        Phone: +49(0)30 – 34 50 95 87
        <br />
        E-Mail: info@loewesaal.de
      </p>

      <p>
        The controller is the natural person or legal entity that
        single-handedly or jointly with others makes decisions as to the
        purposes of and resources for the processing of personal data (e.g.
        names, e-mail addresses, etc.).
      </p>

      <h4>
        <strong>Revocation of your consent to the processing of data</strong>
      </h4>
      <p>
        A wide range of data processing transactions are possible only subject
        to your express consent. You can also revoke at any time any consent you
        have already given us. To do so, all you are required to do is sent us
        an informal notification via e-mail. This shall be without prejudice to
        the lawfulness of any data collection that occurred prior to your
        revocation.
      </p>

      <h4>
        <strong>
          Right to object to the collection of data in special cases; right to
          object to direct advertising (Art. 21 GDPR)
        </strong>
      </h4>
      <p>
        In the event that data are processed on the basis of Art. 6 Sect. 1 lit.
        e or f GDPR, you have the right to at any time object to the processing
        of your personal data based on grounds arising from your unique
        situation. This also applies to any profiling based on these provisions.
        To determine the legal basis, on which any processing of data is based,
        please consult this Data Protection Declaration. If you log an
        objection, we will no longer process your affected personal data, unless
        we are in a position to present compelling protection worthy grounds for
        the processing of your data, that outweigh your interests, rights and
        freedoms or if the purpose of the processing is the claiming, exercising
        or defence of legal entitlements (objection pursuant to Art. 21 Sect. 1
        GDPR).
      </p>

      <p>
        If your personal data is being processed in order to engage in direct
        advertising, you have the right to at any time object to the processing
        of your affected personal data for the purposes of such advertising.
        This also applies to profiling to the extent that it is affiliated with
        such direct advertising. If you object, your personal data will
        subsequently no longer be used for direct advertising purposes
        (objection pursuant to Art. 21 Sect. 2 GDPR).
      </p>

      <h4>
        <strong>
          Right to log a complaint with the competent supervisory agency
        </strong>
      </h4>
      <p>
        In the event of violations of the GDPR, data subjects are entitled to
        log a complaint with a supervisory agency, in particular in the member
        state where they usually maintain their domicile, place of work or at
        the place where the alleged violation occurred. The right to log a
        complaint is in effect regardless of any other administrative or court
        proceedings available as legal recourses. A list of data protection
        officers and their contact details can be found at the following link:
        https://www.bfdi.bund.de/DE/Service/Anschriften/anschriften_table.html
        (Germany) and https://www.data-protection-authority.gv.at/ (Austria).
      </p>

      <h4>
        <strong>Right to data portability</strong>
      </h4>
      <p>
        You have the right to demand that we hand over any data we automatically
        process on the basis of your consent or in order to fulfil a contract be
        handed over to you or a third party in a commonly used, machine readable
        format. If you should demand the direct transfer of the data to another
        controller, this will be done only if it is technically feasible.
      </p>

      <h4>
        <strong>SSL and/or TLS encryption</strong>
      </h4>
      <p>
        For security reasons and to protect the transmission of confidential
        content, such as purchase orders or inquiries you submit to us as the
        website operator, this website uses either an SSL or a TLS encryption
        programme. You can recognise an encrypted connection by checking whether
        the address line of the browser switches from „http://" to „https://"
        and also by the appearance of the lock icon in the browser line.
      </p>

      <p>
        If the SSL or TLS encryption is activated, data you transmit to us
        cannot be read by third parties.
      </p>

      <h4>
        <strong>Encrypted payment transactions on this website</strong>
      </h4>
      <p>
        If you are under an obligation to share your payment information (e.g.
        account number if you give us the authority to debit your bank account)
        with us after you have entered into a fee-based contract with us, this
        information is required to process payments.
      </p>

      <p>
        Payment transactions using common modes of paying (Visa/MasterCard,
        debit to your bank account) are processed exclusively via encrypted SSL
        or TLS connections. You can recognise an encrypted connection by
        checking whether the address line of the browser switches from „http://"
        to „https://" and also by the appearance of the lock icon in the browser
        line.
      </p>

      <p>
        If the communication with us is encrypted, third parties will not be
        able to read the payment information you share with us.
      </p>

      <h4>
        <strong>
          Information about, blockage, rectification and eradication of data
        </strong>
      </h4>
      <p>
        Within the scope of the applicable statutory provisions, you have the
        right to at any time demand information about your archived personal
        data, their source and recipients as well as the purpose of the
        processing of your data. You may also have a right to have your data
        rectified, blocked or eradicated. If you have questions about this
        subject matter or any other questions about personal data, please do not
        hesitate to contact us at any time at the address provided in section
        „Information Required by Law."
      </p>

      <h4>
        <strong>Right to demand processing restrictions</strong>
      </h4>
      <p>
        You have the right to demand the imposition of restrictions as far as
        the processing of your personal data is concerned. To do so, you may
        contact us at any time at the address provided in section „Information
        Required by Law." The right to demand restriction of processing applies
        in the following cases:
      </p>

      <ul>
        <li>
          In the event that you should dispute the correctness of your data
          archived by us, we will usually need some time to verify this claim.
          During the time that this investigation is ongoing, you have the right
          to demand that we restrict the processing of your personal data.
        </li>
        <li>
          If the processing of your personal data was/is conducted in an
          unlawful manner, you have the option to demand the restriction of the
          processing of your data in lieu of demanding the eradication of this
          data.
        </li>
        <li>
          If we do not need your personal data any longer and you need it to
          exercise, defend or claim legal entitlements, you have the right to
          demand the restriction of the processing of your personal data instead
          of its eradication.
        </li>
        <li>
          If you have raised an objection pursuant to Art. 21 Sect. 1 GDPR, your
          rights and our rights will have to be weighed against each other. As
          long as it has not been determined whose interests prevail, you have
          the right to demand a restriction of the processing of your personal
          data.
        </li>
      </ul>
      <p>
        If you have restricted the processing of your personal data, these data
        – with the exception of their archiving – may be processed only subject
        to your consent or to claim, exercise or defend legal entitlements or to
        protect the rights of other natural persons or legal entities or for
        important public interest reasons cited by the European Union or a
        member state of the EU.
      </p>

      <h4>
        <strong>Rejection of unsolicited e-mails</strong>
      </h4>
      <p>
        We herewith object to the use of contact information published in
        conjunction with the mandatory information to be provided in section
        „Information Required by Law" to send us promotional and information
        material that we have not expressly requested. The operators of this
        website and its pages reserve the express right to take legal action in
        the event of the unsolicited sending of promotional information, for
        instance via SPAM messages.
      </p>

      <h3>
        <strong>3. Recording of data on our website</strong>
      </h3>
      <h4>
        <strong>Cookies</strong>
      </h4>
      <p>
        This website uses in particular cookies or other technologies that are
        absolutely necessary or such as functional cookies so that the accessed
        website and functions can be made available to you, Section 25 Paragraph
        2 Number 2 of the Telecommunications Telemedia Data Protection Act
        (TDDDG ), Article 6 paragraph 1 subparagraph 1 letter f GDPR.
      </p>

      <p>
        If you give your consent for optional services and non-essential
        cookies, the legal basis is Section 25 Paragraph 1 TDDDG, Article 6
        Paragraph 1 Subparagraph 1 Letter a GDPR (consent). You can obtain
        further information about this and the cookies or services used at any
        time from the consent management tool used and revoke your consent at
        any time, freely and without disadvantage, with effect for the future.
        Please note, however, that our website does not always function as
        intended without the cookies used.
      </p>

      <p>
        You can view the cookies used in our tool and edit and revoke any
        consent you may have, etc. there at any time. The revocation of consent
        does not affect the lawfulness of the processing carried out based on
        the consent before its revocation.
      </p>

      <h4>
        <strong>Server log files</strong>
      </h4>
      <p>
        The provider of this website and its pages automatically collects and
        stores information in so-called server log files, which your browser
        communicates to us automatically. The information comprises:
      </p>

      <ul>
        <li>The type and version of browser used</li>
        <li>The used operating system</li>
        <li>Referrer URL</li>
        <li>The hostname of the accessing computer</li>
        <li>The time of the server inquiry</li>
        <li>The IP address</li>
      </ul>
      <p>
        This data is not merged with other data sources. This data is recorded
        on the basis of Art. 6 Sect. 1 lit. f GDPR. The operator of the website
        has a legitimate interest in the technically error free depiction and
        the optimization of the operator's website. In order to achieve this,
        server log files must be recorded.
      </p>

      <h4>
        <strong>Contact form</strong>
      </h4>
      <p>
        If you send us inquiries using the contact form, your details from the
        inquiry form, including the contact details you provided there, will be
        stored by us in order to process the inquiry and in case of follow-up
        questions. The legal basis for this is Article 6 paragraph 1
        subparagraph 1 letter b GDPR. We will not pass on this data without your
        consent. The data you enter in the contact form will remain with us
        until you request us to delete it, revoke your consent to storage or the
        purpose for data storage no longer applies (e.g. after your request has
        been processed). Mandatory legal provisions – in particular retention
        periods – remain unaffected.
      </p>

      <h4>
        <strong>Request by e-mail, telephone or fax</strong>
      </h4>
      <p>
        If you contact us by e-mail, telephone or fax, your request, including
        all resulting personal data (name, request) will be stored and processed
        by us for the purpose of processing your request. We do not pass these
        data on without your consent.
      </p>

      <p>
        The processing of these data is based on Art. 6 para. 1 lit. b GDPR, if
        your request is related to the execution of a contract or if it is
        necessary to carry out pre-contractual measures. In all other cases, the
        processing is based on your consent (Article 6 (1) a GDPR) and/or on our
        legitimate interests (Article 6 (1) (f) GDPR), since we have a
        legitimate interest in the effective processing of requests addressed to
        us.
      </p>

      <p>
        The data sent by you to us via contact requests remain with us until you
        request us to delete, revoke your consent to the storage or the purpose
        for the data storage lapses (e.g. after completion of your request).
        Mandatory statutory provisions – in particular statutory retention
        periods – remain unaffected.
      </p>

      <h4>
        <strong>Registration on this website</strong>
      </h4>
      <p>
        You have the option to register on our website to be able to use
        additional website functions. We shall use the data you enter only for
        the purpose of using the respective offer or service you have registered
        for. The required information we request at the time of registration
        must be entered in full. Otherwise we shall reject the registration. The
        legal basis for this is Article 6 paragraph 1 subparagraph 1 letter b
        GDPR.
      </p>

      <p>
        To notify you of any important changes to the scope of our portfolio or
        in the event of technical modifications, we shall use the e-mail address
        provided during the registration process.
      </p>

      <p>
        We shall process the data entered during the registration process on the
        basis of your consent (Art. 6 Sect. 1 lit. a GDPR). You have the right
        to revoke at any time any consent you have already given us. To do so,
        all you are required to do is sent us an informal notification via
        e-mail. This shall be without prejudice to the lawfulness of any data
        collection that occurred prior to your revocation.
      </p>

      <p>
        The data recorded during the registration process shall be stored by us
        as long as you are registered on our website. Subsequently, such data
        shall be deleted. This shall be without prejudice to mandatory statutory
        retention obligations.
      </p>

      <h4>
        <strong>Processing of data (customer and contract data)</strong>
      </h4>
      <p>
        We collect, process and use personal data only to the extent necessary
        for the establishment, content organization or change of the legal
        relationship (data inventory). These actions are taken on the basis of
        Art. 6 Sect. 1 lit. b GDPR, which permits the processing of data for the
        fulfilment of a contract or pre-contractual actions. We collect, process
        and use personal data concerning the use of our website (usage data)
        only to the extent that this is necessary to make it possible for users
        to utilize the services and to bill for them.
      </p>

      <p>
        The collected customer data shall be eradicated upon completion of the
        order or the termination of the business relationship. This shall be
        without prejudice to any statutory retention mandates.
      </p>

      <h3>
        <strong>4. Plugins und tools</strong>
      </h3>
      <h4>
        <strong>Google Web Fonts (local embedding)</strong>
      </h4>
      <p>
        This website uses so-called Web Fonts provided by Google to ensure the
        uniform use of fonts on this site. These Google fonts are locally
        installed so that a connection to Google's servers will not be
        established in conjunction with this application.
      </p>

      <h4>
        <strong>Google Maps</strong>
      </h4>
      <p>
        Via an API, this website uses the mapping service Google Maps. The
        provider is Google Ireland Limited („Google"), Gordon House, Barrow
        Street, Dublin 4, Ireland.
      </p>

      <p>
        To enable the use of the Google Maps features, your IP address must be
        stored. As a rule, this information is transferred to one of Google's
        servers in the United States, where it is archived. The operator of this
        website has no control over the data transfer.
      </p>

      <p>
        The use of Google Maps is in the interest of an attractive presentation
        of our online offerings and to make it easy to find the places we
        indicate on the website. This represents a legitimate interest within
        the meaning of Art. 6 Para. 1 lit. f GDPR. Furthermore, the Google
        services are only actively loaded if you have previously given your
        consent, Art. 6 Para. 1 lit. a GDPR.
      </p>

      <p>
        For more information on the handling of user data, please review
        Google's Data Privacy Declaration under:
        https://policies.google.com/privacy?hl=en.
      </p>

      <h4>
        <strong>Adobe Fonts</strong>
      </h4>
      <p>
        In order to ensure the uniform depiction of certain fonts, our website
        uses fonts called Adobe Fonts provided by Adobe Systems Incorporated,
        345 Park Avenue, San Jose, CA 95110-2704, USA (Adobe).
      </p>

      <p>
        When you access pages of our website, your browser will automatically
        load the required fonts directly from the Adobe site to be able to
        display them correctly on your device. As a result, your browser will
        establish a connection with Adobe's servers in the United States. Hence,
        Adobe learns that your IP address was used to access our website.
        According to the information provided by Adobe, no cookies will be
        stored in conjunction with the provision of the fonts.
      </p>

      <p>
        Adobe is in possession of a certification in accordance with the EU-US
        Privacy Shield. The Privacy Shield is a compact ratified between the
        United States of America and the European Union, aiming to warrant
        compliance with European Data Protection Standards. For more
        information, please follow this link:
        https://www.adobe.com/privacy/eudatatransfers.html.
      </p>

      <p>
        The use of Adobe Fonts is necessary to ensure a consistent typeface on
        our website. This represents a legitimate interest within the meaning of
        Article 6 Paragraph 1 Letter f of the GDPR. Furthermore, the services
        will only be actively loaded if you have previously given your consent,
        Article 6 Paragraph 1 Letter a of the GDPR.
      </p>

      <p>
        For more information about Adobe Fonts, please read the policies under:
        https://www.adobe.com/privacy/policies/adobe-fonts.html.
      </p>

      <p>
        Adobe's Data Privacy Declaration may be reviewed under:
        https://www.adobe.com/privacy/policy.html.
      </p>

      <h4>
        <strong>YouTube with expanded data protection integration</strong>
      </h4>
      <p>
        Our website uses plug-ins of the YouTube platform, which is being
        operated by Google Ireland Limited („Google"), Gordon House, Barrow
        Street, Dublin 4, Ireland.
      </p>

      <p>
        We use YouTube in the expanded data protection mode. According to
        YouTube, this mode ensures that YouTube does not store any information
        about visitors to this website before they watch the video.
        Nevertheless, this does not necessarily mean that the sharing of data
        with YouTube partners can be ruled out as a result of the expanded data
        protection mode. For instance, regardless of whether you are watching a
        video, YouTube will always establish a connection with the Google
        DoubleClick network.
      </p>

      <p>
        As soon as you start to play a YouTube video on our website, a
        connection to YouTube's servers will be established. As a result, the
        YouTube server will be notified, which of our pages you have visited. If
        you are logged into your YouTube account while you visit our site, you
        enable YouTube to directly allocate your browsing patterns to your
        personal profile. You have the option to prevent this by logging out of
        your YouTube account.
      </p>

      <p>
        Furthermore, after you have started to play a video, YouTube will be
        able to place various cookies on your device. With the assistance of
        these cookies, YouTube will be able to obtain information about our
        website visitor. Among other things, this information will be used to
        generate video statistics with the aim of improving the user
        friendliness of the site and to prevent attempts to commit fraud. These
        cookies will stay on your device until you delete them.
      </p>

      <p>
        Under certain circumstances, additional data processing transactions may
        be triggered after you have started to play a YouTube video, which are
        beyond our control.
      </p>

      <p>
        The use of YouTube is in the interest of an attractive presentation of
        our online offerings. This represents a legitimate interest within the
        meaning of Art. 6 Para. 1 lit. f GDPR. Furthermore, the Google services
        are only actively loaded if you have previously given your consent, Art.
        6 Para. 1 lit. a GDPR. If you have given your consent to the processing
        of personal data, you have the right of revocation, Article 7 GDPR, with
        effect for the future. The lawfulness of processing based on consent
        until its revocation remains unaffected.
      </p>

      <p>
        For more information on how YouTube handles user data, please consult
        the YouTube Data Privacy Policy under:
        https://policies.google.com/privacy?hl=en.
      </p>

      <h4>
        <strong>Vimeo</strong>
      </h4>
      <p>
        Our website uses plug-ins of the video portal Vimeo. The provider is
        Vimeo Inc., 555 West 18th Street, New York, New York 10011, USA.
      </p>

      <p>
        If you visit one of the pages on our website into which a Vimeo plug-in
        has been integrated, a connection to Vimeo's servers will be
        established. As a consequence, the Vimeo server will receive information
        as to which of our pages you have visited. Moreover, Vimeo will receive
        your IP address. This will also happen if you are not logged into Vimeo
        or do not have an account with Vimeo. The information recorded by Vimeo
        will be transmitted to Vimeo's server in the United States.
      </p>

      <p>
        If you are logged into your Vimeo account, you enable Vimeo to directly
        allocate your browsing patterns to your personal profile. You can
        prevent this by logging out of your Vimeo account.
      </p>

      <p>
        The use of Vimeo is in the interest of an attractive presentation of our
        online offerings. This represents a legitimate interest within the
        meaning of Article 6 Paragraph 1 Letter f of the GDPR. Furthermore, the
        services will only be actively loaded if you have previously given your
        consent, Article 6 Paragraph 1 Letter a of the GDPR. If you have given
        your consent to the processing of personal data, you have the right of
        revocation, Article 7 GDPR, with effect for the future. The lawfulness
        of processing based on consent until its revocation remains unaffected.
      </p>

      <p>
        For more information on how Vimeo handles user data, please consult the
        Vimeo Data Privacy Policy under: https://vimeo.com/privacy.
      </p>
    </div>
  );
};

export default Datenschutz;
